export default __webpack_public_path__ + "static/media/tweeter_icon.c8b144c2.png";